import React from 'react';
import CountUp from 'react-countup';

const TotalBoxes = ({ heading, codeCount, renderGrowth, image }) => {

  return (
    <div
      className='counter-box'
      style={{
        backgroundColor: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        borderRadius: '12px',
        alignSelf: "stretch",
        fontFamily: "Outfit",
        minHeight: "120px",
        minWidth: 0,
        padding: '20px 12px 16px',
        border: '1px solid #e8e8e8',
        boxShadow: '0 2px 6px rgba(0,0,0,0.04)',
      }}
    >
      <div
        style={{
          width: '40px',
          height: '40px',
          borderRadius: '50%',
          background: 'rgb(243, 243, 243)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '8px',
        }}
      >
        <img
          style={{ width: '20px', height: '20px' }}
          src={image}
          alt='logo'
        />
      </div>

      <h1
        style={{
          color: '#1C1C1C',
          fontWeight: '700',
          fontSize: '20px',
          lineHeight: '1.2',
          margin: '0 0 4px',
        }}
      >
        {typeof codeCount === 'number' ? <CountUp
          start={0}
          end={codeCount ?? 0}
          duration={2.5}
          separator=','
        /> : codeCount}
      </h1>
      <h1
        style={{
          color: '#929292',
          fontWeight: '400',
          fontSize: '13px',
          lineHeight: '1.3',
          margin: 0,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxWidth: '100%',
          textAlign: 'center',
        }}
      >
        {heading}
      </h1>
      {renderGrowth && <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '4px',
          marginTop: '6px',
        }}
      >
        <span
          style={{
            color: '#01A207',
            fontWeight: '400',
            fontSize: '12px',
            lineHeight: '1.2',
          }}
        >
          {renderGrowth()}
        </span>
      </div>}
    </div>
  );
};

export default TotalBoxes;
